<script>
  export let src = '';
</script>

<div class="specs-modal__line-value">
  <img class="rounded specs-modal__img" {src} alt="">
</div>

<style lang="scss">
  .specs-modal__img {
    width: 100%;
		margin-right: 10px;
    transition: all .15s ease-in-out;
	}

  .specs-modal__line-value {
    min-width: 135px;
    max-width: 135px;
    margin-right: 10px;
    text-align: center;
    font-size: 14px;
    padding: 3px 0;

    @media (min-width: 576px) {
      min-width: 220px;
      max-width: 220px;
      margin-right: 30px;
      padding-top: 8px;
      padding-bottom: 8px;
      font-size: 16px;
    }

    @media (min-width: 768px) {
      margin-right: 40px;
    }
  }
</style>